const OPERATORS = {
  contiene:      { value: 'contiene',      label: 'Contiene' },
  no_contiene:   { value: 'no_contiene',   label: 'No contiene' },
  igual:         { value: 'igual',         label: 'Igual' },
  diferente:     { value: 'diferente',     label: 'Diferente' },
  mayor:         { value: 'mayor',         label: 'Mayor' },
  menor:         { value: 'menor',         label: 'Menor' },
  mayor_igual:   { value: 'mayor_igual',   label: 'Mayor o igual' },
  menor_igual:   { value: 'menor_igual',   label: 'Menor o igual' },
  entre:         { value: 'entre',         label: 'Entre' },
  mayor_que_hoy: { value: 'mayor_que_hoy', label: 'Mayor que hoy' },
  menor_que_hoy: { value: 'menor_que_hoy', label: 'Menor que hoy' },
  igual_a_hoy:   { value: 'igual_a_hoy',   label: 'Igual a hoy' },
};

const STRING_OPS  = [OPERATORS.contiene, OPERATORS.no_contiene, OPERATORS.igual, OPERATORS.diferente];
const NUMBER_OPS  = [OPERATORS.igual, OPERATORS.diferente, OPERATORS.mayor, OPERATORS.menor, OPERATORS.mayor_igual, OPERATORS.menor_igual, OPERATORS.entre];
const DATE_OPS    = [OPERATORS.igual, OPERATORS.diferente, OPERATORS.mayor, OPERATORS.menor, OPERATORS.mayor_igual, OPERATORS.menor_igual, OPERATORS.entre];
const DATE_TODAY_OPS = [OPERATORS.mayor_que_hoy, OPERATORS.menor_que_hoy, OPERATORS.igual_a_hoy];
const SELECT_OPS  = [OPERATORS.contiene, OPERATORS.igual, OPERATORS.diferente];
const REF_OPS     = [OPERATORS.igual, OPERATORS.diferente];

const TYPE_MAP = {
  answer_string:      STRING_OPS,
  email:              STRING_OPS,
  answer_text:        STRING_OPS,
  code_format:        STRING_OPS,
  answer_integer:     NUMBER_OPS,
  answer_formula:     NUMBER_OPS,
  dynamic_field:      NUMBER_OPS,
  answer_date:        DATE_OPS,
  answer_autdatetime: DATE_OPS,
  answer_datetime:    DATE_OPS,
  answer_time:        DATE_OPS,
  answer_hour:        DATE_OPS,
  answer_select:      SELECT_OPS,
  answer_radio:       SELECT_OPS,
  answer_checkbox:    SELECT_OPS,
  answer_user_id:     REF_OPS,
  proceso_id:         REF_OPS,
  position_id:        REF_OPS,
};

export function getOperatorsForType(questionType, options = {}) {
  const ops = TYPE_MAP[questionType] || STRING_OPS;
  if (options.includeTodayOps && ['answer_date', 'answer_autdatetime', 'answer_datetime'].includes(questionType)) {
    return [...ops, ...DATE_TODAY_OPS];
  }
  return ops;
}

// Maps old format ("Igual", "Mayor e igual") and new format ("igual", "mayor_igual") to label
const LEGACY_MAP = {
  'Contiene': 'contiene', 'No contiene': 'no_contiene', 'Igual': 'igual',
  'Diferente': 'diferente', 'Mayor': 'mayor', 'Menor': 'menor',
  'Mayor e igual': 'mayor_igual', 'Menor e igual': 'menor_igual',
  'Entre: ejemplo 10 y 20': 'entre', 'Entre': 'entre',
  'Mayor que hoy': 'mayor_que_hoy', 'Menor que hoy': 'menor_que_hoy', 'Igual a hoy': 'igual_a_hoy',
};

// Normalizes old format to new format value (e.g. "Mayor e igual" -> "mayor_igual")
export function normalizeOperation(operationValue) {
  return LEGACY_MAP[operationValue] || operationValue;
}

export function getOperatorLabel(operationValue) {
  const normalized = normalizeOperation(operationValue);
  const found = Object.values(OPERATORS).find(op => op.value === normalized);
  return found ? found.label : operationValue;
}

export function getInputType(questionType) {
  if (['answer_integer', 'answer_formula', 'dynamic_field'].includes(questionType)) return 'number';
  if (['answer_date', 'answer_autdatetime', 'answer_datetime'].includes(questionType)) return 'date';
  if (['answer_time', 'answer_hour'].includes(questionType)) return 'time';
  return 'text';
}

export const EXCLUDED_TYPES = ['format_id', 'answer_subform', 'answer_localization', 'localization', 'answer_matrix', 'answer_file', 'answer_signature'];
